import {BillingProvider} from "../types.ts";
import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {NavLink} from "react-router-dom";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {moduleConfig} from "../config";

// The read-mode columns; RecordsTable appends the Actions column (repo CLAUDE.md).
// Every column here is sortable (§3a). The `accessor` is what sorts: `created` sorts as
// ISO-8601, `status` on the enum's text. Status renders through the module's one
// StatusBadge, the same as the detail page (§13).
export const useBillingProvidersTableColumns = () => {

    const columns: DataTableColumn<BillingProvider>[] = [
        {
            accessor: 'name',
            title: I18n.get('Billing Provider Name'),
            width: '1fr',
            sortable: true,
            // A real link: keyboard-reachable, and it opens the detail route (§3, §13).
            render: (item: BillingProvider) => (
                <NavLink to={`${moduleConfig.basePath}/${item.id}`}>{item.name || item.key}</NavLink>
            ),
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            sortable: true,
            render: (item: BillingProvider) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            sortable: true,
            render: (item: BillingProvider) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    }
}
